import { render, staticRenderFns } from "./SynonymListManage.vue?vue&type=template&id=25f2aad3&"
import script from "./SynonymListManage.vue?vue&type=script&lang=js&"
export * from "./SynonymListManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25f2aad3')) {
      api.createRecord('25f2aad3', component.options)
    } else {
      api.reload('25f2aad3', component.options)
    }
    module.hot.accept("./SynonymListManage.vue?vue&type=template&id=25f2aad3&", function () {
      api.rerender('25f2aad3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/SynonymListManage/SynonymListManage.vue"
export default component.exports